import { render, staticRenderFns } from "./LoginNew.vue?vue&type=template&id=3cd335ca&"
import script from "./LoginNew.vue?vue&type=script&lang=ts&"
export * from "./LoginNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports